<template>
  <div class="register-page">
    <newHeaderTop></newHeaderTop>
    <div v-if="!verificationModel" class="form">
      <P class="form-title">{{ $t('300031') }}</P>
      <!--      <span class="block">{{$t('300032')}}</span>-->
      <div class="register-tab">
        <!--邮箱-->
        <div class="tab inline-block" @click="handleChange('email')"
             :class="{activeTab:activeName == 'email',tabMarL:isDirection,tabMarR:!isDirection}">{{ $t('300033') }}
        </div>
        <!--手机-->
        <div class="tab inline-block" @click="handleChange('phone')"
             :class="{activeTab:activeName == 'phone',tabMarL:isDirection,tabMarR:!isDirection}">{{ $t('300034') }}
        </div>
      </div>
      <form>
        <div class="form-item" v-show="activeName == 'email'">
          <p class="form-item-label">{{ $t('300033') }}</p>
          <div class="form-item-value">
            <input v-model="temp.emailUser" @blur="emailBlur" :class="emailError ? 'error-border' : ''"/>
          </div>
          <span class="error-msg" v-show="emailError">{{ emailErrorMsg }}</span>
        </div>
        <div class="form-item" v-show="activeName == 'phone'">
          <p class="form-item-label">{{ $t('300035') }}</p>
          <div class="form-item-value flex-between">
            <div class="country-code relative">
              <p class="country flex-between pointer" :class="phoneError ? 'error-border' : ''"
                 @click="vanPopupShow = !vanPopupShow">
                <img :src="countryImg" alt="">
                <span>+{{ temp.areaCode }}</span>
                <i class="iconfont" :class="vanPopupShow ? 'icon-shangla' : 'icon-xiala'"></i>
              </p>
            </div>
            <!--输入手机号-->
            <input v-model="temp.phoneUser" @blur="phoneBlur" maxlength="11" class="phoneNumber"
                   :class="phoneError ? 'error-border' : ''"/>
          </div>
          <span class="error-msg" v-show="phoneError">{{ phoneErrorMsg }}</span>
        </div>
        <div class="form-item">
          <p class="form-item-label">{{ $t('300036') }}</p>
          <div class="form-item-value password-item" :class="isDirection ? 'password-item-rtl' : 'password-item-ltr'">
            <input v-model="temp.password" @blur="passwordBlur" :type="inputType"
                   :class="passwordError ? 'error-border' : ''"/>
            <i @click="changeType" class="iconfont eyeIcon absolute pointer"
               :class="inputType == 'password' ? 'icon-yincang' : 'icon-chakan'"></i>
          </div>
          <span class="error-msg" v-show="passwordError">{{ passwordErrorMsg }}</span>
        </div>
        <div class="form-item">
          <p class="form-item-label">{{ $t('300037') }}
            <i class="iconfont" :class="inviteCodeInput ? 'icon-shangla' : 'icon-xiala'"
               @click="inviteCodeInput = !inviteCodeInput"></i>
          </p>
          <div class="form-item-value">
            <input :class="!!this.$route.query.invitationCode ? 'disabled-input' : ''"
                   v-show="inviteCodeInput || temp.inviteCode != ''" :disabled="!!this.$route.query.invitationCode"
                   v-model="temp.inviteCode"/>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-value" style="display:flex;flex-wrap: wrap">
            <svg @click="checked = !checked" v-show="!checked" class="icon pointer checkIcon"
                 aria-hidden="true">
              <use xlink:href="#icon-weixuanzhong"></use>
            </svg>
            <svg @click="checked = !checked" v-show="checked" class="icon pointer checkIcon"
                 aria-hidden="true">
              <use xlink:href="#icon-xuanzhong"></use>
            </svg>
            <!--我已阅读并同意--> <!--《SuperEx服务条款》-->
            <span class="service">{{ $t('300038') }}<a
              :href="language == 'zh-TC' ? 'https://superexhelp.zendesk.com/hc/zh-hk/articles/4410464395033' : language == 'ko' ? 'https://superexhelp.zendesk.com/hc/ko/articles/4411046370457' : 'https://superexhelp.zendesk.com/hc/en-001/articles/4411055405337'">《{{
                $t('300039')
              }}》</a></span>
            <!--我已满18岁,并同意SuperEx服务条款-->
            <span class="block error-tip" v-show="!checked && submitStatus">{{ $t('300040') }}</span>
          </div>
        </div>
      </form>
      <van-button type="primary" @click="submit">{{ $t('300041') }}</van-button>
      <p class='loginFun'>{{$t('300327')}}<span class='loginBtn' @click="toLogin">{{$t('300328')}}</span></p>
    </div>
    <verification v-if="verificationModel" :user-name="activeName == 'phone' ? temp.phoneUser : temp.emailUser"
                  :area-code="temp.areaCode" :isGeet="isGeet" :type="activeName" form-type="register"
                  @submitFun="submitFun" :isCountDown="isCountDown" @countDownFun="countDownFun"
                  @backFun="backFun"></verification>
    <van-popup v-model="vanPopupShow" round position="bottom" :style="{ height: '50%' }" class="country-popup">
      <div class="popup-title">{{ $t('300043') }}
        <van-icon name="cross" @click="vanPopupShow = false"/>
      </div>
      <div class="country-list">
        <div class="search" :class="isDirection ? 'search-rtl' : 'search-ltr'">
          <i class="iconfont icon-sousuo"></i>
          <input type="text" v-model="keyWord" :placeholder="$t('300044')">
        </div>
        <div class="list-item" v-for="item in list" @click="changeCountry(item)">
          <div class="flex-center">
            <img :src="item.nationalFlagUrl" alt="">
            <span class="country-name">&nbsp;&nbsp;{{
                language == 'zh-CN' ? item.chineseName : item.englishName
              }}{{ language != 'zh-CN' && item.name ? '(' + item.name + ')' : '' }}</span>
          </div>
          <div class="area-code">+{{ item.code }}</div>
        </div>
      </div>
    </van-popup>
    <appDown @close="close" v-if="appDownShow"></appDown>
    <div class="loading-model" v-if="loadingShow">
      <div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%">
        <img :src="staticState+'static/images/loading.gif'" alt="">
      </div>
    </div>
    <Geet :isGeet="isgt" @geetPath="GeetPath" :user-name="activeName == 'phone' ? temp.phoneUser : temp.emailUser"
          @clickChange="GeetChange" product="bind" v-if="showImgCode"></Geet>
    <!--    <div class="model" v-if="showImgCode" @click="showImgCode = false">-->
    <!--      <div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%">-->
    <!--        <VueHcaptcha sitekey="4f12a0ca-d812-40e1-a599-b642bf9e8988" @verify="onVerify"></VueHcaptcha>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import appDown from "../compontents/appDown";
import newHeaderTop from "../compontents/newHeaderTop";
import {Toast, Field, Button, Popup, Icon, Dialog} from 'vant'
import Methods from "../utils/methods";
import {buryingPoint, getCountryList} from "../api/user";
import {mapGetters} from 'vuex'
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
import verification from "../compontents/verification";
import {sendCode, register} from "../api/user";
import {setToken} from "../utils/auth";
import * as config from '../../config/config'
import Geet from "../compontents/Geet";
import { languageArr, languageName } from '@/utils/utilsType'
import { setCookie,getCookie } from '@/utils/auth'
import {parseTime} from "../utils";

export default {
  name: "register",
  components: {
    appDown,
    newHeaderTop,
    vanField: Field,
    vanButton: Button,
    vanPopup: Popup,
    vanIcon: Icon,
    VueHcaptcha,
    verification,
    Geet
  },
  data() {
    return {
      isgt: false,
      appDownShow: true,
      activeName: 'email',
      temp: {
        areaCode: '1',
        inviteCode: '',
        password: '',
        phoneUser: '',
        emailUser: '',
        validateCode: '',
      },
      verificationModel: false,
      showImgCode: false,
      checked: false,
      countryImg: '',
      countryModel: false,
      inputType: 'password',
      inviteCodeInput: '',
      emailErrorMsg: '',
      emailError: false,
      phoneErrorMsg: '',
      phoneError: false,
      passwordErrorMsg: '',
      passwordError: false,
      countryList: [],
      submitStatus: false,
      vanPopupShow: false,
      keyWord: '',
      isGeet: true,
      isCountDown: true,
      staticState: config[config.Edition].staticState,
      loadingShow: false,
      historyBack: '',
    }
  },
  computed: {
    ...mapGetters(['language', 'isDirection','user','session_id','page_session_id']),
    list() {
      if (this.keyWord == '') {
        return this.countryList
      } else {
        var arr = [];
        let cuntry = null;
        this.countryList.forEach(v => {
          if (v.code === this.keyWord || v.chineseName === this.keyWord || v.countriesAndRegions === this.keyWord || v.englishName === this.keyWord || v.name === this.keyWord) {
            cuntry = v
          } else if (v.code.substr(0, this.keyWord.length) === this.keyWord || v.chineseName.substr(0, this.keyWord.length) === this.keyWord || v.countriesAndRegions.substr(0, this.keyWord.length).toLowerCase() === this.keyWord.toLowerCase() || v.englishName.substr(0, this.keyWord.length).toLowerCase() === this.keyWord.toLowerCase() || v.name.substr(0, this.keyWord.length) === this.keyWord) {
            arr.splice(0, 0, v)
          } else if (v.code.indexOf(this.keyWord) != -1 || v.chineseName.indexOf(this.keyWord) != -1 || v.countriesAndRegions.toLowerCase().indexOf(this.keyWord.toLowerCase()) != -1 || v.englishName.toLowerCase().indexOf(this.keyWord.toLowerCase()) != -1 || v.name.indexOf(this.keyWord) != -1) {
            arr.push(v)
          }
        })
        if (cuntry) {
          return [cuntry, ...arr]
        } else {
          return arr
        }
        /*var arr = []
        this.countryList.forEach(v => {
          if (v.code.indexOf(this.keyWord) != -1 || v.chineseName.indexOf(this.keyWord) != -1 || v.countriesAndRegions.indexOf(this.keyWord) != -1 || v.englishName.indexOf(this.keyWord) != -1) {
            arr.push(v)
          }
        })
        return arr*/
      }
    }
  },
  watch: {
    'temp.phoneUser': {
      deep: true,
      handler(nv, ov) {
        if (String(nv).indexOf('.') > 0) this.temp.phoneUser = '';
        this.$nextTick(() => { //这里
          this.temp.phoneUser = String(nv).replace(/\D/g, '');
        });
      }
    },
    '$route.query.invitationCode': {
        immediate: true,
        handler(newVal) {
            if (newVal) {
                this.appDownShow = false;
            }
        }
    }
  },
  created() {
    console.log(this.$route.query.invitationCode,'this.$route.query.invitationCode');
    if(this.$route.query.invitationCode){
        this.appDownShow = false
    }
    this.historyBack = this.$route.query.historyBack || ''
    this.change_language()
    window.document.documentElement.setAttribute("dir", this.isDirection ? 'rtl' : 'ltr');
    window.document.documentElement.setAttribute(
            'dir',
            this.IsShow() ? 'rtl' : 'ltr'
        )
    this.getCountryList()
    // if(this.$route.query.invitationCode){
    //   sessionStorage.setItem('invitationCode',this.$route.query.invitationCode)
    // }
    this.temp.inviteCode = this.$route.query.invitationCode || sessionStorage.getItem('invitationCode') ||  ''
  },
  methods: {
    toLogin(){
      analytics.track("Open Page Button Clicked",{
        trigger:'registion_page_log_in_buttion'
      });
      this.$router.push('/login')
    },
    IsShow(){
        return getCookie('language') == 'fa'?true:false
    },
    change_language(){
        let paramsName = this.$route.query.language
        let inviteCode = this.$route.query.invitationCode || sessionStorage.getItem('invitationCode') ||  ''
        const language = getCookie('language')||'en'
        if(paramsName!=language){
            if(languageArr.indexOf(paramsName)!==-1){
                setCookie('language',paramsName)
                this.$store.dispatch('setLanguageName',languageName[paramsName])
                setCookie('languageName', languageName[paramsName])
                document.documentElement.setAttribute('lang', paramsName)
                setTimeout(() => {
                    this.$i18n.locale = paramsName
                }, 500)
                // inviteCode
                if(!inviteCode){
                    this.$router.replace(`/register?language=${paramsName}&historyBack=${this.historyBack}`)
                }else{
                    this.$router.replace(`/register?invitationCode=${inviteCode}&&language=${paramsName}&historyBack=${this.historyBack}`)
                }
            }else{
                if(!inviteCode){
                    this.$router.replace(`/register?language=${language}&historyBack=${this.historyBack}`)
                }else{
                    this.$router.replace(`/register?invitationCode=${inviteCode}&&language=${language}&historyBack=${this.historyBack}`)
                }
            }
        }
    },
    telephoneShow(phone) {
      return Methods.telephoneShow(phone)
    },
    emailShow(email) {
      return Methods.telephoneShow(email)
    },
    handleChange(name) {
      this.activeName = name
      this.temp.password = ''
      this.temp.phoneUser = ''
      this.temp.emailUser = ''
      if (name == 'phone') {
        this.temp.areaCode = '1'
        this.countryImg = this.countryList.find(v => v.code == this.temp.areaCode).nationalFlagUrl
      }
      this.emailError = false
      this.emailErrorMsg = ''
      this.phoneError = false
      this.phoneErrorMsg = ''
      this.passwordError = false
      this.passwordErrorMsg = ''
    },
    submit() {
      if (!this.checked) {
        this.submitStatus = true
        return false
      }
      if (this.activeName == 'email' && (this.emailError || this.passwordError)) {
        return false
      } else if (this.activeName == 'phone' && (this.phoneError || this.passwordError)) {
        return false
      } else {
        analytics.track("Registion Submitted",{
          email:this.temp.emailUser || '',
          mobile_number:this.temp.phoneUser ? this.temp.areaCode + '' + this.temp.phoneUser : '',
          referral_id:this.temp.inviteCode || undefined,
          trigger:'registion_page_register_button'
        });
        // let dataParams = {
        //   'event_id':'submit_registion',
        //   session_id:this.session_id || '',
        //   terminal:'web',
        //   prop:{
        //     page_session_id:this.page_session_id,
        //     user_id:this.$store.getters.user.id || '',
        //     date_time:new Date()*1,
        //     ip:'',
        //     email:this.temp.emailUser || '',
        //     mobile_number:this.temp.phoneUser || '',
        //     referral_id:this.temp.inviteCode || undefined,
        //     trigger:'registion_page_register_button'
        //   }
        // }
        // // console.log(dataParams,'dataParams')
        // buryingPoint(dataParams).then(res=>{})
        this.showImgCode = true
        this.$nextTick(() => {
          this.isgt = !this.isgt
        })
      }
    },
    submitFun(code) {
      var timeZone = -new Date().getTimezoneOffset() / 60
      var data = {
        userName: this.activeName == 'phone' ? this.temp.phoneUser : this.temp.emailUser,
        password: this.temp.password,
        validateCode: code,
        areaCode: this.activeName == 'phone' ? this.temp.areaCode : undefined,
        client: 1,
        inviteCode: this.temp.inviteCode || undefined,
        language: this.langFilter(navigator.language),  // 获取浏览器语言
        timeZone: timeZone   // 当前时区
      }
      if (this.requestLocked) {
        return false;
      }
      this.requestLocked = true
      register(data).then(res => {
        if (res.data.code == 200) {
          this.resDataCode(res)
          this.requestLocked = false
        } else {
          Toast(res.data.msg)
          this.requestLocked = false
        }

      })
    },
    resDataCode(res) {
      if (res.data.data.token) {
        setToken(res.data.data.token)
        this.$store.dispatch('setToken', res.data.data.token)
      }
      if (this.historyBack) {
        let href = window.decodeURIComponent(this.historyBack)
        console.log(href,'===href===');
        // this.$router.push(href)
        this.$router.push('/registersSuc')
        return false
      }else{
        // this.$router.push('/')
        this.$router.push('/registersSuc')
      }
      analytics.identify(this.user.id||'');
    },
    countDownFun() {
      this.isCountDown = false
    },
    phoneBlur() {
      var reg = /^[0-9]*$/
      if (this.temp.phoneUser == '') {
        this.phoneError = true
        this.phoneErrorMsg = this.$t('300045') // 请输入你的手机号
      } else if (this.temp.phoneUser.length < 5 || !reg.test(this.temp.phoneUser)) {
        this.phoneError = true
        this.phoneErrorMsg = this.$t('300046')// '请输入正确的手机号码'
      } else {
        this.phoneError = false
        this.phoneErrorMsg = ''
      }
    },
    emailBlur() {
      var reg = /^\w+(?:\.\w+){0,2}@[a-zA-Z0-9]{2,14}(?:\.[a-z]{2,}){1,3}$/
      if (this.temp.emailUser == '') {
        this.emailError = true
        this.emailErrorMsg = this.$t('300047')//'请输入你的邮箱地址'
      } else if (!reg.test(this.temp.emailUser)) {
        this.emailError = true
        this.emailErrorMsg = this.$t('300048')//'请输入有效的电子邮件地址'
      } else {
        this.emailError = false
        this.emailErrorMsg = ''
      }
    },
    passwordBlur() {
      var reg = /^(?=.*[0-9].*)(?=.*[A-Z].*).{8,}$/
      var regCopy = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d!"#$%&'()*+,-./:;<=>?@^_{}~|\[\]\\`]{8,}$/

      if (this.temp.password == '') {
        this.passwordError = true
        this.passwordErrorMsg = this.$t('300049') //'请输入你的密码'
      } else if (!reg.test(this.temp.password)) {
        this.passwordError = true
        this.passwordErrorMsg = this.$t('300050') //'至少8位字符,必须包含1位大写字母及1位数字'
      } else if (!regCopy.test(this.temp.password)) {
        this.passwordError = true
        this.passwordErrorMsg = this.$t('300065') //'请输入英文字母或常用标点符号'
      } else {
        this.passwordError = false
        this.passwordErrorMsg = ''
      }
    },
    changeType() {
      this.inputType = this.inputType == 'password' ? 'text' : 'password'
    },
    close() {
      this.appDownShow = false
    },
    // 第一步获取验证码
    getSendCode(val) {
      var data = {
        behaviorToken: val,
        type: 1,
      }
      if (this.activeName == 'phone') {
        data.phone = this.temp.phoneUser
        data.areaCode = this.temp.areaCode
      } else {
        data.email = this.temp.emailUser
      }
      this.showImgCode = false
      this.loadingShow = true
      sendCode(this.activeName, data).then(res => {
        if (res.code == '200') {
          this.loadingShow = false
          this.verificationModel = true
        } else {
          this.loadingShow = false
        }
      }).catch(() => {
        this.loadingShow = false
      })
    },
    GeetChange(val) {
      this.isgt = val;
    },
    // 点击注册按钮时滑块
    GeetPath(val) {
      this.getSendCode(val)
    },
    getCountryList() {
      var data = []
      getCountryList().then(res => {
        res.data.forEach(v => {
          if (v.allowedRegister) {
            data.push(v)
          }
        })
        this.countryList = data
      })
    },
    backFun() {
      this.verificationModel = false
    },
    changeCountry(item) {
      this.countryImg = item.nationalFlagUrl || ''
      this.temp.areaCode = item.code || '82'
      this.vanPopupShow = false
    },
    langFilter(lang) {
      if (lang == 'zh-Tw' || lang == 'zh-HK') {
        return 'zh-TC'
      } else if (lang.indexOf('fa') > -1) {
        return 'fa'
      } else {
        return lang
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../style/mixin";
@import "../assets/css/variableName";

body{
    background-color: #ffffff;
    // color: #333333;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block {
  display: block;
}

.register-page {
  height: 100vh;
  padding-top: torem(46);
  position: relative;
  background: #FFFFFF;
  .form {
    padding: torem(32) torem(28) torem(60);

    .form-title {
      @include sc(torem(24), #333333);
      margin-bottom: torem(7);
    }

    span.block {
      @include sc(torem(13), #666);
    }

    .register-tab {
      width: 100%;
      border-bottom: torem(0.5) solid #EFEFEF;
      margin-bottom: torem(24);
      margin-top: torem(32);

      .inline-block {
        display: inline-block;
      }

      .tab {
        @include sc(torem(15), #666);
        font-weight: bold;
        padding-bottom: torem(6);
      }

      .tabMarL {
        margin-left: torem(17);
      }

      .tabMarR {
        margin-right: torem(17);
      }

      .activeTab {
        color: #333;
        border-bottom: torem(2) solid #FFC72B;
      }
    }

    .form-item {
      margin-bottom: torem(24);

      input {
        width: 100%;
        height: torem(44);
        line-height: torem(44);
        border-radius: torem(1);
        border: torem(0.5) solid #DCDFE6;
        @include sc(torem(14), #333);
        padding: 0 torem(15);
        background-color: #fff;

        &:focus {
          border-color: #FFC72B;
        }
      }

      &-label {
        font-size: 0.65rem;
        color: #333;
        margin-bottom: 0.4rem;

        i {
          @include sc(torem(10), #999);
        }
      }

      &-value {
        font-size: torem(12);
        margin-bottom: torem(5);

        .checkIcon {
          width: torem(16);
          height: torem(15);
          vertical-align: torem(-4);
        }

        .country {
          width: torem(100);
          margin-right: torem(4);
          border: torem(0.5) solid #DCDFE6;
          border-radius: torem(1);
          height: torem(44);
          padding: 0 torem(10);
          font-size: torem(15);
          color: #333;

          img {
            max-width: torem(24);
            max-height: torem(24);
          }

          &:hover {
            border-color: #FFC72B;
          }

          i {
            @include sc(torem(10), #999);
          }
        }

        .error-border {
          border-color: #F56C6C;
        }

        .phoneNumber {
          width: calc(100% - #{torem(110)});
        }

        .service {
          margin-left: torem(3);
          @include sc(torem(12), #333);
          line-height: 1.2;

          a {
            color: #FFC72B;
          }
        }

        .error-tip {
          margin-top: torem(8);
          @include sc(torem(12), #D35D5D);
        }

        .disabled-input {
          background-color: #EEF1F5;
          color: #999999;
        }
      }

      .error-msg {
        @include sc(torem(12), #D35D5D);
      }

      .password-item {
        position: relative;

        .absolute {
          position: absolute;
        }

        .eyeIcon {
          top: torem(16);
          color: #BCBCBC;
          font-size: torem(15);
        }
      }

      .password-item-ltr {
        input {
          padding-right: torem(33);
        }

        .eyeIcon {
          right: torem(16);
        }
      }

      .password-item-rtl {
        input {
          padding-left: torem(33);
        }

        .eyeIcon {
          left: torem(16);
        }
      }
    }

    /deep/ .van-button {
      width: 100%;
      height: torem(44);
      @include sc(torem(16), #333);
      background-color: #FFC72B;
      border: none;
    }
  }
}

.verification-model {
  padding: torem(12) torem(25);

  .back-icon {
    i {
      display: inline-block;
      @include sc(torem(14), #BCBCBC);
      line-height: torem(22);
      margin-bottom: torem(28);
    }
  }

  .title {
    @include sc(torem(24), #333);
    margin-bottom: torem(48);

    .title-tip {
      margin-top: torem(10);
      @include sc(torem(14), #666);
    }
  }

  .verification-form {

  }
}

.country-popup {
  .popup-title {
    display: flex;
    justify-content: space-between;
    padding: torem(24) torem(16) torem(16);
    @include sc(torem(18), #333);
  }

  .country-list {
    .search {
      width: 100%;
      padding: 0 torem(24);
      position: relative;
      color: #333333;
      input {
        height: torem(36);
        width: 100%;
        border: torem(0.5) solid #DCDFE6;
        font-size: torem(14);
      }

      .iconfont {
        position: absolute;
        top: torem(11);
        @include sc(torem(16), #999);
      }
    }

    .search-ltr {
      input {
        padding-left: torem(45);
        padding-right: torem(10);
      }

      .iconfont {
        left: torem(40);
      }
    }

    .search-rtl {
      input {
        padding-right: torem(45);
        padding-left: torem(10);
      }

      .iconfont {
        right: torem(40);
      }
    }

    .list-item {
      width: 100%;
      padding: torem(16) torem(22);
      @include sc(torem(15), #333);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .country-name {
        padding: torem(5) 0;
        @include sc(torem(14), #333);
        width: torem(230);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .flex-center {
        display: flex;
        align-items: center;

        img {
          max-width: torem(20);
          max-height: torem(20);
        }
      }

      /* .area-code{
         display: inline-block;
         direction: ltr;
       }*/

      /deep/ .van-icon {
        @include sc(torem(20), #FFC72B);
      }
    }
  }
}

.model {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9999;

  /deep/ .van-icon {
    @include sc(torem(18), #333);
    margin-right: torem(20);
    float: right;
  }
}

.loading-model {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 9999;
  top: 0;
  background: rgba(0, 0, 0, 0.1);

  img {
    width: torem(50);
    height: torem(50);
  }
}
.loginFun{
  margin-top: torem(16);
  font-size: torem(12);
  color: #000922;
  .loginBtn{
    color:#FFC72B ;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/register.vue